module.exports = __webpack_public_path__ + "r-v3/img/ml_40_00.8020fe6d.jpg";